import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import BannerImage from '../../Components/BannerImage';
import Container from '../../Components/Container';

function RouteNotFound() {
  return (
    <React.Fragment>
      <Helmet>
        <title>
          Fish Toronto | Page not found
        </title>
      </Helmet>
      <BannerImage
        title="404 Fish Not Found"
        img="/Images/Locations/Island.jpeg"
      />
      <Container>
        <h2>
          It looks like something went wrong
        </h2>
        <h3>
          Maybe one of our quick links can help
        </h3>
        <ul>
          <li>
            <Link to="/">
              Home
            </Link>
          </li>
        </ul>
      </Container>
    </React.Fragment>
  );
}

export default RouteNotFound;



// WEBPACK FOOTER //
// ./src/Routes/RouteNotFound/index.jsx